import { createAsyncThunk } from "@reduxjs/toolkit";
import getApiUrl from "../../../api";

const asyncDataByUuid = createAsyncThunk(
    'accounting/getViewed',
    async function({uuid, year}) {
        const promise = await fetch(
            getApiUrl() + `/api/user/data-by-uuid?year=${year}&userUuid=${uuid}`
        );

        switch (promise.status) {
            case 200:
                const json = promise.json();
                return json;
            case 400:
                throw Error("Произошла ошибка запроса");
            case 403:
                throw Error("Отказано в доступе");
            case 500:
                throw Error("Ошибка сервера");
            default:
                break
        }
    }
)

export default asyncDataByUuid;